"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreDisputeStatus = exports.CoreDisputeType = void 0;
var CoreDisputeType;
(function (CoreDisputeType) {
    CoreDisputeType["INITIAL_ATTEMPT"] = "initial_attempt";
    CoreDisputeType["MEDIATION"] = "mediation";
    CoreDisputeType["ARBITRATION"] = "arbitration";
    CoreDisputeType["LITIGATION"] = "litigation";
    // Resolution types
    CoreDisputeType["MUTUAL_RESOLUTION"] = "mutual_resolution";
    CoreDisputeType["FORMAL_RESOLUTION"] = "formal_resolution";
    CoreDisputeType["FORMAL_RESOLUTION_WITH_PARTIAL_RELEASE"] = "formal_resolution_with_partial_release";
    CoreDisputeType["FORMAL_RESOLUTION_WITH_REFUND"] = "formal_resolution_with_refund";
})(CoreDisputeType || (exports.CoreDisputeType = CoreDisputeType = {}));
var CoreDisputeStatus;
(function (CoreDisputeStatus) {
    CoreDisputeStatus["PENDING"] = "pending";
    CoreDisputeStatus["REVIEW"] = "review";
    CoreDisputeStatus["RESOLVED"] = "resolved";
    CoreDisputeStatus["REJECTED"] = "rejected";
})(CoreDisputeStatus || (exports.CoreDisputeStatus = CoreDisputeStatus = {}));
